import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LawyersApiService } from 'src/app/core/services/api/lawyers-api.service';
import { cities } from 'src/app/shared/models/cities';
import { Client } from 'src/app/shared/models/clients/client';
import { countries } from 'src/app/shared/models/countries';
import { NgSelectProps } from 'src/app/shared/models/ng-select-props';

@Component({
  selector: 'app-client-details-form',
  templateUrl: './client-details-form.component.html',
  styleUrls: ['./client-details-form.component.scss']
})
export class ClientDetailsFormComponent implements OnInit {
  @Input() c: Client;
  clientCopy: Client;
  @Output() updateClientEvent = new EventEmitter<Client>();
  @Output() closeFormEvent = new EventEmitter<Client>();
  countries = countries;
  cities = cities;
  lawyerNgSelect;

  constructor(
    private lawyerApi: LawyersApiService) { }

  ngOnInit(): void {
    this.clientCopy = Object.assign(new Client(), this.c);
    this.lawyerNgSelect = new NgSelectProps(this.lawyerApi.getLawyers);
  }

  onClientDetailUpdate() {
    this.clientCopy.crmLawyerId = this.clientCopy.crmLawyer ? this.clientCopy.crmLawyer.id : null;
    this.updateClientEvent.emit(this.clientCopy);
  }

  dismissEdit() {
    this.closeFormEvent.emit();
  }

  searchFn() {
    return true;
  }
}
